import { api } from '@/services'

export const fetchPayments = (params) => {
    return api.get('admin/payment/listHostsPayments', { params })
}
export const payHost = (params) => {
    return api.post('admin/payment/payHost', params)
}